import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { findIndex, insert, propEq } from 'ramda';
import { useRouting } from '@alycecom/hooks';

import { setIsDonation, setProduct } from '../store/giftFlow/giftFlow.actions';
import { MARKETPLACE_DONATE_ROUTE, MARKETPLACE_ITEMS_ROUTE } from '../constants/marketplaceRoute.constants';
import { getStatuses, getActiveStatus } from '../store/giftFlow/giftFlow.selectors';
import { getNextStepUrl } from '../helpers/giftStatusSteps.helpers';
import { getGiftHashId, getGiftProduct, getIsGift } from '../store/data/data.selectors';
import { GIFT_FLOW_SHIPPING_STEP, GIFT_FLOW_CONFIRMATION_ID } from '../../../constants/giftFlow.constants';
import { getStatuses as getStatusFlags } from '../store/statuses/statuses.selectors';

export default parentUrl => {
  const dispatch = useDispatch();
  const go = useRouting();

  const hashId = useSelector(getGiftHashId);
  const statuses = useSelector(getStatuses);
  const activeStatus = useSelector(getActiveStatus);
  const sentProduct = useSelector(getGiftProduct);
  const statusFlags = useSelector(getStatusFlags);
  const isGift = useSelector(getIsGift);

  const handleAccept = useCallback(
    (product, confirmedFlowStepId = null) => {
      const isProductChanged = sentProduct && product && sentProduct.id !== product.id;
      const isProductAddressRequired = isProductChanged ? product.isAddressRequired : statusFlags.address;
      const isCodeAddressRequired = !isGift;

      const confirmStepIndex = findIndex(propEq('id', GIFT_FLOW_CONFIRMATION_ID), statuses);
      const shippingStep = { ...GIFT_FLOW_SHIPPING_STEP, route: `/${hashId}/${GIFT_FLOW_SHIPPING_STEP.route}` };

      const giftStatuses =
        product.fromMarketplace && (isProductAddressRequired || isCodeAddressRequired)
          ? insert(confirmStepIndex, shippingStep, statuses)
          : statuses;

      dispatch(setProduct(product));

      const nextStepUrl = getNextStepUrl(giftStatuses, activeStatus, confirmedFlowStepId);
      go(nextStepUrl);
    },
    [go, hashId, statuses, activeStatus, sentProduct, statusFlags, isGift, dispatch],
  );

  const handleDonate = useCallback(() => {
    dispatch(setIsDonation(true));
    go(`${parentUrl}/marketplace/${MARKETPLACE_DONATE_ROUTE}`);
  }, [go, parentUrl, dispatch]);

  const handleExchange = useCallback(
    (useDonation = false) => {
      dispatch(setIsDonation(useDonation));
      const marketplaceRoute = useDonation ? MARKETPLACE_DONATE_ROUTE : MARKETPLACE_ITEMS_ROUTE;
      go(`${parentUrl}/marketplace/${marketplaceRoute}`);
    },
    [go, parentUrl, dispatch],
  );

  return {
    handleAccept,
    handleDonate,
    handleExchange,
  };
};
